import { Outlet, createFileRoute } from '@tanstack/react-router';
import ActionButton from '@/components/Button/ActionButton';
import { ProductLogoMediumPermissionAndRoles as LogoPermissionAndRoles } from '@/components/Logo';
import type { TabWithIndicatorProps } from '@/components/Navigation/HeaderTabs';
import { ProductHeader } from '@/components/ProductHeader';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import { useTranslation } from '@/lib/i18n';
export const Route = createFileRoute('/_staff/settings/permission-and-roles/_list')({
  component: RouteComponent
});
function RouteComponent() {
  const {
    t
  } = useTranslation();
  const tabs = [{
    to: '/settings/permission-and-roles/roles',
    children: t('common.list.permissionAndRoles.roles')
  }, {
    to: '/settings/permission-and-roles/people-groups',
    children: t('common.list.permissionAndRoles.peopleGroups')
  }, {
    to: '/settings/permission-and-roles/product-permissions',
    children: t('common.list.permissionAndRoles.productPermissions')
  }, {
    to: '/settings/permission-and-roles/category-permissions' as const,
    children: t('common.list.permissionAndRoles.categoryPermissions')
  }] satisfies TabWithIndicatorProps[];
  const help = {
    title: t('common.list.permissionAndRoles.help.title'),
    description: t('common.list.permissionAndRoles.help.description')
  };
  return <div className="flex flex-col">
      <ProductHeader Logo={LogoPermissionAndRoles} name={t('pages.settings.permissionAndRoles.title')} tabs={tabs} type="resource">
        <HelpDialog help={help} />
      </ProductHeader>
      <Outlet />
    </div>;
}
function HelpDialog({
  help
}: {
  help: {
    title: string;
    description: string;
  };
}) {
  return <Dialog>
      <DialogTrigger asChild>
        <ActionButton className="ml-auto" variant="ghost" icon="CircleHelpIcon" iconColor="muted" />
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{help.title}</DialogTitle>
        </DialogHeader>
        <DialogDescription className="whitespace-pre-wrap text-neutral-on-fill">
          {help.description}
        </DialogDescription>
      </DialogContent>
    </Dialog>;
}